import React from "react";
import { SparksCancellationWinbackPage } from "./SparksCancellationWinbackPage";
import { SparksPaywallPage } from "./SparksPaywallPage";

export const SparksPaywallExperience = ({ search }: { search: string }) => {
  const queryParams = new URLSearchParams(search);
  if (!queryParams.has("winbackId")) {
    return <SparksPaywallPage />;
  }

  return (
    <SparksCancellationWinbackPage
      winbackId={queryParams.get("winbackId") ?? ""}
      email={queryParams.get("email") ?? ""}
    />
  );
};
